import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44da7f9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "reg" }
const _hoisted_2 = {
  key: 0,
  class: "reg-lt"
}
const _hoisted_3 = {
  key: 1,
  class: "reg-ct"
}
const _hoisted_4 = { class: "reg-ct-box" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("返回")
const _hoisted_6 = {
  class: "top clearfix",
  style: {"position":"absolute","right":"30px","top":"30px"}
}
const _hoisted_7 = {
  class: "imgbox000 fr",
  style: {"position":"relative"}
}
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 2,
  class: "txttips"
}
const _hoisted_11 = {
  key: 3,
  class: "txttips"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "reg-ct-box-title" }, "我是", -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode("地产/物业")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("品牌厂家")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("社区商家")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("第三方服务商")
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "reg-ct-box-title" }, "微信扫码注册", -1))
const _hoisted_18 = ["src"]
const _hoisted_19 = {
  key: 2,
  class: "reg-lt-max"
}
const _hoisted_20 = { class: "reg-lt-max-center" }
const _hoisted_21 = { class: "reg-lt-max-title" }
const _hoisted_22 = ["src"]
const _hoisted_23 = /*#__PURE__*/_createTextVNode("发送验证码")
const _hoisted_24 = { key: 1 }
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" 验证码有效 ")
const _hoisted_26 = { style: {"color":"red"} }
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" 秒")
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" 我已经阅读")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("《社区美居网会员协议》")
const _hoisted_30 = /*#__PURE__*/_createTextVNode("中所述内容，并同意遵守其内容 ")
const _hoisted_31 = /*#__PURE__*/_createTextVNode("提交注册")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("重新选择")
const _hoisted_33 = {
  key: 3,
  class: "reg-lt-max"
}
const _hoisted_34 = { class: "reg-lt-max-center" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "reg-lt-max-title",
  style: {"color":"#ff6600"}
}, "准会员注册成功", -1))
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" 恭喜！注册完成，请妥善保管以下资料： ")
const _hoisted_37 = /*#__PURE__*/_createTextVNode("会员帐号/登录名：")
const _hoisted_38 = /*#__PURE__*/_createTextVNode("登录密码：")
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" 注意：账号和密码不可给他人使用，否则引起的资金和项目报名等债任，需账号拥有者负责。 ")
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" 我们即将开始审核，请支付会员费，以享受完整的服务。 ")
const _hoisted_41 = /*#__PURE__*/_createTextVNode("支付会员费")
const _hoisted_42 = /*#__PURE__*/_createTextVNode("完善资料")
const _hoisted_43 = /*#__PURE__*/_createTextVNode("回到首页")
const _hoisted_44 = { class: "reg-rt" }
const _hoisted_45 = { class: "reg-rt-box" }
const _hoisted_46 = { class: "reg-rt-box" }
const _hoisted_47 = { class: "reg-rt-box" }

import { defineComponent } from "vue";
import store from "@/store/index";
import { useStore } from "@/store/index";
import { ref, reactive } from "vue";
import { ElButton, ElMessage, ElMessageBox } from "element-plus";
import type { ElForm, Action } from "element-plus";

import tool from "@/utils/tool";
import router from "@/router/index";
import { Plus } from "@element-plus/icons-vue";
import type {
  UploadFile,
  ElFile,
} from "element-plus/es/components/upload/src/upload.type";

type FormInstance = InstanceType<typeof ElForm>;

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const showUiIndex = ref(1);

var id = router.currentRoute.value.params.id;
var type = 1;
var status = 1;
if (id != "all") {
  type = Number(id);
  status = 2;
}
const nameText = type == 4 ? "姓名" : "企业全称";
const bindData = reactive({
  status: status,
  typeName: '地产/物业',
  timerCount: 0,
  nameText: nameText,
  image1: require('@/assets/fd/reglog/reg-1.jpg'),
  image2: require('@/assets/fd/reglog/reg-2.jpg'),
  image3: require('@/assets/fd/reglog/reg-3.jpg'),
  registerForm: {
    type: type,
    code: "",
    name: "",
    shortName: "",
    licenseNo: "",
    licenseFile: "",
    logo: "",
    brandLogo: "",
    brandBigLogo: "",
    brandName: "",
    contact: "",
    mobile: "",
    tel: "",
    companyAreaIds: "",
    companyAreaIdList: [],
    companyFace: "",
    remark: "",
    website: "",
    province: "",
    city: "",
    area: "",
    address: "",
    corporateRepresentative: "",
    registeredFund: 0,
    industry: "",
    businessCategory: "",
    teamSize: 0,
    handbagCertificateLevel: "",
    storefront: "",
    licenseFileFullPath: "",
    logoFullPath: "",
    brandBigLogoFullPath: "",
    brandLogoFullPath: "",
    areaId: "",
    isPublic: "",
    verificationCode: "",
    isRead: false
  },
  regResult: {
    code: "",
    mobile: "",
    password: "",
  }
});

const edit = (type: number) => {
  bindData.registerForm.type = type;
  bindData.status = 2;
  bindData.nameText = type == 4 ? "姓名" : "企业全称";
  switch (type) {
    case 1:
      bindData.typeName = '地产/物业';
      bindData.image1 = require('@/assets/fd/reglog/regProp-1.jpg');
      bindData.image2 = require('@/assets/fd/reglog/regProp-2.jpg');
      bindData.image3 = require('@/assets/fd/reglog/regProp-3.jpg');
      break;
    case 2:
      bindData.typeName = '品牌厂家';
      bindData.image1 = require('@/assets/fd/reglog/regSupp-1.jpg');
      bindData.image2 = require('@/assets/fd/reglog/regSupp-2.jpg');
      bindData.image3 = require('@/assets/fd/reglog/regSupp-3.jpg');
      break;
    case 3:
      bindData.typeName = '社区商家';
      bindData.image1 = require('@/assets/fd/reglog/regComm-1.jpg');
      bindData.image2 = require('@/assets/fd/reglog/regComm-2.jpg');
      bindData.image3 = require('@/assets/fd/reglog/regComm-3.jpg');
      break;
    case 4:
      bindData.typeName = '业主/个人';
      // bindData.image1 = '@/assets/fd/reglog/';
      // bindData.image2 = '@/assets/fd/reglog/';
      // bindData.image3 = '@/assets/fd/reglog/';
      break;
    case 5:
      bindData.typeName = '第三方服务商';
      bindData.image1 = require('@/assets/fd/reglog/reg3PS-1.jpg');
      bindData.image2 = require('@/assets/fd/reglog/reg3PS-2.jpg');
      bindData.image3 = require('@/assets/fd/reglog/reg3PS-3.jpg');
      break;
    default:
      break;
  }
}

const editEvent = (type: number) => {
  router.push('/frontDesk/register/' + type);
  edit(type);
}

if (id != "all") {
  edit(type);
}

const goTo = (url: string) => {
  router.push(url);
}

const goToEditInfo = () => {
  if (type == 4) {
    goTo('/middleGround/my/information');
  }
  else {
    goTo('/middleGround/member/index');
  }

}

const goToPayment = () => {
  goTo('/middleGround/member/membershipFees');
}

const registerFormRef = ref<FormInstance>();

const registerRules = type == 4 ? reactive({
  name: [{ required: true, message: "请填写姓名", trigger: "blur" }],
  mobile: [{ required: true, message: "请填写手机号", trigger: "blur" }],
  verificationCode: [{ required: true, message: "请填写验证码", trigger: "blur" }],
}) : reactive({
  name: [{ required: true, message: "请填写企业全称", trigger: "blur" }],
  shortName: [{ required: true, message: "请填写企业简称", trigger: "blur" }],
  licenseNo: [{ required: true, message: "请填写企业信用代码", trigger: "blur" }],
  licenseFile: [{ required: true, message: "请上传营业执照", trigger: "blur" }],
  contact: [{ required: true, message: "请填写联系人", trigger: "blur" }],
  mobile: [{ required: true, message: "请填写手机号", trigger: "blur" }],
  verificationCode: [{ required: true, message: "请填写验证码", trigger: "blur" }],
});

const handleLicenseFileSuccess = (
  response: any,
  file: UploadFile,
  fileList: UploadFile[]
) => {
  bindData.registerForm.licenseFile = response.result;
  bindData.registerForm.licenseFileFullPath = URL.createObjectURL(
    file.raw
  );
};

const beforeUploadCheckEvent = (file: ElFile) => {
  let types = ["image/jpeg", "image/gif", "image/bmp", "image/png"];
  const isImage = types.includes(file.type);
  const isLt2M = file.size / 1024 / 1024 < 2;

  if (!isImage) {
    ElMessage.error("上传的图片必须是JPG,GIF,BMP,PNG格式!");
  }
  if (!isLt2M) {
    ElMessage.error("上传的图片文件大小不能超过2MB!");
  }
  return isImage && isLt2M;
};

const sendSmsRegister = () => {
  if (bindData.registerForm.mobile == null || bindData.registerForm.mobile.length != 11) {
    ElMessage.error("请正确填写手机号.");
    return;
  }
  var params = {
    mobile: bindData.registerForm.mobile
  };
  store.dispatch('frontRegisterModule/sendSmsRegister', params).then(
    (data) => {
      console.log(data);
      //成功
      ElMessage.success("发送成功.");
      timer(data.result);
    },
    (error) => {
      console.log(error.msg);
      ElMessage.error(error.msg);
    }
  );
}

const sendSmsRegisterNext = () => {
  if (bindData.registerForm.mobile == null || bindData.registerForm.mobile.length != 11) {
    return;
  }
  if (bindData.registerForm.verificationCode == null || bindData.registerForm.verificationCode.length != 6) {
    return;
  }
  var params = {
    mobile: bindData.registerForm.mobile,
    checkCode: bindData.registerForm.verificationCode
  };
  store.dispatch('frontRegisterModule/sendSmsRegisterNext', params).then(
    (data) => {
      console.log(data);
      //成功
      ElMessage.success("验证成功.");
    },
    (error) => {
      console.log(error.msg);
      ElMessage.error(error.msg);
      bindData.registerForm.verificationCode = '';
    }
  );
}

var intervalId: NodeJS.Timer;
const timer = (time: number) => {
  bindData.timerCount = time;
  intervalId = setInterval(() => {
    bindData.timerCount = bindData.timerCount - 1;
    if (bindData.timerCount <= 0) {
      if (intervalId) {
        clearInterval(Number(intervalId));
      }
    }
  }, 1000);
}

const submitForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return;

  if (!bindData.registerForm.isRead) {
    ElMessage.error("请阅读会员入会协议");
    return;
  }

  formEl.validate((valid) => {
    if (valid) {
      store
        .dispatch(
          "frontRegisterModule/saveRegister",
          bindData.registerForm
        )
        .then(
          (data) => {
            //成功
            ElMessage.success("注册成功.");
            bindData.regResult = data.result;
            bindData.status = 3;
          },
          (error) => {
            ElMessageBox.alert(error.msg, "系统消息", {
              confirmButtonText: "关闭",
              callback: (action: Action) => { },
            });
          }
        );
    } else {
      console.log("error submit!");
      return false;
    }
  });
};

const resetForm = (formEl: FormInstance | undefined) => {
  console.log("exec...resetForm");
  if (!formEl) return;
  formEl.resetFields();
};

const backToChooseEvent = () => {
  bindData.status = 1;
  bindData.image1 = require('@/assets/fd/reglog/reg-1.jpg');
  bindData.image2 = require('@/assets/fd/reglog/reg-2.jpg');
  bindData.image3 = require('@/assets/fd/reglog/reg-3.jpg');
}

const handleToBack = () => {
  //router.push('/')
  router.back();
}

const showUiChange = (id: number) => { 
  showUiIndex.value=id;
}

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, { class: "reg-box" }, {
      default: _withCtx(() => [
        (_unref(bindData).status == 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_el_image, {
                src: require('@/assets/fd/login_bg.jpg')
              }, null, 8, ["src"])
            ]))
          : _createCommentVNode("", true),
        (_unref(bindData).status == 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_unref(ElButton), {
                  type: "text",
                  class: "reg-ct-box-return",
                  onClick: handleToBack
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    (showUiIndex.value==2)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "pt",
                          style: {"cursor":"pointer"},
                          src: require('@/assets/fd/diannao.jpg'),
                          title: "切换到PC填写注册",
                          alt: "",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (showUiChange(1)))
                        }, null, 8, _hoisted_8))
                      : _createCommentVNode("", true),
                    (showUiIndex.value==1)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          class: "pt",
                          style: {"cursor":"pointer"},
                          src: require('@/assets/fd/erweima.jpg'),
                          title: "切换到扫码注册",
                          alt: "",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (showUiChange(2)))
                        }, null, 8, _hoisted_9))
                      : _createCommentVNode("", true),
                    (showUiIndex.value==1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, "微信扫码注册"))
                      : _createCommentVNode("", true),
                    (showUiIndex.value==2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, "PC填写注册"))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (showUiIndex.value==1)
                  ? (_openBlock(), _createBlock(_component_el_form, {
                      key: 0,
                      id: "pc_register"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_12,
                        _createVNode(_component_el_form_item, { class: "reg-ct-box-btn" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(ElButton), {
                              type: "primary",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (editEvent(1)))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_13
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { class: "reg-ct-box-btn" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(ElButton), {
                              type: "primary",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (editEvent(2)))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_14
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { class: "reg-ct-box-btn" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(ElButton), {
                              type: "primary",
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (editEvent(3)))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_15
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { class: "reg-ct-box-btn" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(ElButton), {
                              type: "primary",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (editEvent(5)))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_16
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (showUiIndex.value==2)
                  ? (_openBlock(), _createBlock(_component_el_form, {
                      key: 1,
                      id: "weixin_register"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_17,
                        _createVNode(_component_el_form_item, null, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              style: {"cursor":"pointer"},
                              src: require('@/assets/fd/qrcode_register2.png'),
                              title: "注册二维码",
                              alt: ""
                            }, null, 8, _hoisted_18)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(bindData).status == 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(bindData).typeName) + ".会员注册资料", 1),
                _createVNode(_component_el_form, {
                  model: _unref(bindData).registerForm,
                  ref_key: "registerFormRef",
                  ref: registerFormRef,
                  rules: _unref(registerRules),
                  "label-width": "120px",
                  class: "reg-lt-max-form"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(bindData).nameText,
                      prop: "name"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(bindData).registerForm.name,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(bindData).registerForm.name) = $event)),
                          "input-style": [{ width: '300px' }],
                          placeholder: "",
                          size: "default"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    (_unref(bindData).registerForm.type != 4)
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 0,
                          label: "企业简称",
                          prop: "shortName"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _unref(bindData).registerForm.shortName,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(bindData).registerForm.shortName) = $event)),
                              "input-style": [{ width: '300px' }],
                              placeholder: "2~8个字",
                              size: "default"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_unref(bindData).registerForm.type != 4)
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 1,
                          label: "企业信用代码",
                          prop: "licenseNo"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _unref(bindData).registerForm.licenseNo,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(bindData).registerForm.licenseNo) = $event)),
                              "input-style": [{ width: '300px' }],
                              placeholder: "",
                              size: "default"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_unref(bindData).registerForm.type != 4)
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 2,
                          label: "营业执照",
                          prop: "licenseFile"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_container, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_upload, {
                                  class: _normalizeClass(["avatar-uploader", 
                  _unref(bindData).registerForm.licenseFile && 'cur-uploader'
                ]),
                                  action: _unref(tool).url('/frontend/index/anon/uploadImageFile'),
                                  "show-file-list": false,
                                  "on-success": handleLicenseFileSuccess,
                                  "before-upload": beforeUploadCheckEvent
                                }, {
                                  default: _withCtx(() => [
                                    (_unref(bindData).registerForm.licenseFile)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: _unref(bindData).registerForm.licenseFileFullPath,
                                          class: "avatar"
                                        }, null, 8, _hoisted_22))
                                      : (_openBlock(), _createBlock(_component_el_icon, {
                                          key: 1,
                                          class: "avatar-uploader-icon"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(Plus))
                                          ]),
                                          _: 1
                                        }))
                                  ]),
                                  _: 1
                                }, 8, ["class", "action"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_unref(bindData).registerForm.type != 4)
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 3,
                          label: "联系人",
                          prop: "contact"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _unref(bindData).registerForm.contact,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(bindData).registerForm.contact) = $event)),
                              "input-style": [{ width: '300px' }],
                              placeholder: "",
                              size: "default"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_form_item, {
                      label: "手机号",
                      prop: "mobile"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_row, { gutter: 20 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _unref(bindData).registerForm.mobile,
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(bindData).registerForm.mobile) = $event)),
                                  "input-style": [{ width: '200px' }],
                                  placeholder: "",
                                  size: "default"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 12 }, {
                              default: _withCtx(() => [
                                (_unref(bindData).timerCount <= 0)
                                  ? (_openBlock(), _createBlock(_unref(ElButton), {
                                      key: 0,
                                      type: "default",
                                      onClick: sendSmsRegister
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_23
                                      ]),
                                      _: 1
                                    }))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_24, [
                                      _hoisted_25,
                                      _createElementVNode("em", _hoisted_26, _toDisplayString(_unref(bindData).timerCount), 1),
                                      _hoisted_27
                                    ]))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "验证码",
                      prop: "verificationCode"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(bindData).registerForm.verificationCode,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(bindData).registerForm.verificationCode) = $event)),
                          "input-style": [{ width: '300px' }],
                          placeholder: "",
                          size: "default",
                          onBlur: sendSmsRegisterNext
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_container, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_checkbox, {
                          modelValue: _unref(bindData).registerForm.isRead,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(bindData).registerForm.isRead) = $event))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_28,
                            _createVNode(_component_el_link, { type: "primary" }, {
                              default: _withCtx(() => [
                                _hoisted_29
                              ]),
                              _: 1
                            }),
                            _hoisted_30
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model", "rules"]),
                _createVNode(_component_el_container, { class: "reg-btn" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElButton), {
                      type: "primary",
                      size: "large",
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (submitForm(registerFormRef.value)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_31
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(ElButton), {
                      type: "default",
                      size: "large",
                      onClick: backToChooseEvent
                    }, {
                      default: _withCtx(() => [
                        _hoisted_32
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(bindData).status == 3)
          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _hoisted_35,
                _createVNode(_component_el_row, {
                  gutter: 20,
                  class: "list-row"
                }, {
                  default: _withCtx(() => [
                    _hoisted_36
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, {
                  gutter: 20,
                  class: "list-row"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, {
                      span: 14,
                      class: "col-left"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_37
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, {
                      span: 10,
                      class: "col-right"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(bindData).regResult.code), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, {
                  gutter: 20,
                  class: "list-row"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, {
                      span: 14,
                      class: "col-left"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_38
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, {
                      span: 10,
                      class: "col-right",
                      style: {"color":"#ff6600"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(bindData).regResult.password), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, {
                  gutter: 20,
                  class: "list-row"
                }, {
                  default: _withCtx(() => [
                    _hoisted_39
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, {
                  gutter: 20,
                  class: "list-row"
                }, {
                  default: _withCtx(() => [
                    _hoisted_40
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_container, { class: "reg-btn" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElButton), {
                      type: "warning",
                      size: "large",
                      onClick: goToPayment
                    }, {
                      default: _withCtx(() => [
                        _hoisted_41
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(ElButton), {
                      type: "primary",
                      size: "large",
                      onClick: goToEditInfo
                    }, {
                      default: _withCtx(() => [
                        _hoisted_42
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(ElButton), {
                      type: "default",
                      size: "large",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (goTo('/frontDesk/index')))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_43
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            _createVNode(_component_el_image, {
              fit: "fill",
              src: _unref(bindData).image1
            }, null, 8, ["src"])
          ]),
          _createElementVNode("div", _hoisted_46, [
            _createVNode(_component_el_image, {
              fit: "fill",
              src: _unref(bindData).image2
            }, null, 8, ["src"])
          ]),
          _createElementVNode("div", _hoisted_47, [
            _createVNode(_component_el_image, {
              fit: "fill",
              src: _unref(bindData).image3
            }, null, 8, ["src"])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})